import React from "react";

const BenefitsSection = () => {
    const benefits = [
        {
            title: "Wide Coverage",
            description:
                "Our platform connects you with partners and services across multiple states, ensuring you get the support you need wherever you are.",
            icon: "🌎",
        },
        {
            title: "Seamless Experience",
            description:
                "Enjoy a user-friendly platform designed to make your interactions simple, efficient, and stress-free.",
            icon: "⚡",
        },
        // {
        //     title: "Trusted by Many",
        //     description:
        //         "Join a growing community of satisfied users who trust us to deliver consistent quality and reliability.",
        //     icon: "⭐",
        // },
        {
            title: "Future-Focused",
            description:
                "We are constantly innovating to bring you new features, expanded coverage, and a commitment to growth.",
            icon: "🚀",
        },
    ];

    return (
        <div className="bg-gray-50 py-12">
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">
                    Why Choose Our Platform?
                </h2>
                <p className="text-lg text-gray-600 text-center mb-10">
                    Discover the benefits of partnering with us and see how we make your journey easier and more rewarding.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                        >
                            <div className="text-4xl mb-4">{benefit.icon}</div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                {benefit.title}
                            </h3>
                            <p className="text-gray-600 text-center">{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BenefitsSection;
